import { colors, HStack } from "goi_common";
import { InputHTMLAttributes } from "react";

const TextField = ({
  borderColor = colors.orange650,
  ...props
}: InputHTMLAttributes<HTMLInputElement> & { borderColor?: string }) => {
  return (
    <HStack
      css={{
        borderBottom: `1px solid ${borderColor}`,
      }}
      gap="8px"
      alignItems="center"
    >
      <input
        className="body_16_r"
        css={{
          padding: "4px 8px",
          outline: "none",
          width: "100%",
        }}
        {...props}
      />
    </HStack>
  );
};

export default TextField;
